import React from 'react'
import styled from 'styled-components'
import Text from '../shared/Text'
import RecentChargeCard from './RecentChargeCard'
import RetryButton from '../shared/RetryButton'
import styles from '../../utility/styles'
import { formatNumber } from '../../utility/helpers'

const Wrapper = styled.div`
	padding-bottom: 38px;
	border-bottom: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08));
`

const ChargesWrapper = styled.div`
    display: flex;
    align-items: center;
    overflow: scroll;
`

/**
 * 
 * @param {{
 *   charges:any[],
 *   error:string,
 *   power:number,
 *   retry:()=>Promise<void>
 * }} props
 * @returns 
 */
export default function RecentCharges({ charges = [], power, error, retry }) {
    return (
        <Wrapper>
            <Text.Heading type='h5' variant='bold' style={{ marginBottom: '24px' }}>Recent Charges</Text.Heading>
            {Boolean(error) && <RetryButton style={{ margin: 'auto' }} onClick={retry} />}
            <ChargesWrapper>
                {charges.map(charge => (
                    <RecentChargeCard 
                        key={charge?.id}
                        startPct={charge?.charge_start_percent}
                        endPct={charge?.charge_end_percent}
                        startRange={`${formatNumber(charge?.charge_start_range)}${charge?.distance_units}`}
                        endRange={`${formatNumber(charge?.charge_end_range)}${charge?.distance_units}`}
                        startTs={charge?.start_ts}
                        endTs={charge?.stop_ts}
                        duration={charge?.duration_s}
                        chartData={charge?.chart_data}
                        carbon={charge?.carbon?.co2_g}
                        carbonRelative={charge?.carbon?.global_relative}
                        rangeDiff={`${charge?.range_diff}${charge?.distance_units}`}
                        carType={charge?.car_type}
                        {...{ power }}
                    />
                ))}
            </ChargesWrapper>
        </Wrapper>
    )
}

